import { defineMessages } from 'react-intl-next';

export default defineMessages({
    portalLogoAlt: {
        defaultMessage: '{portalName} portal logo',
        description: 'Alt text for portal logo on portal card',
        id: 'help-center.portal.card.portal-logo-alt',
    },
});
